<template>
  <div>
    {{ dateUtil(new Date(item.inspectionDate), false, "FEHLER") }}
  </div>
</template>
<script>
import { dateUtil } from "../../api/api";
export default {
  props: ["item"],
  methods: {
    dateUtil,
  },
};
</script>
